"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_STYLES = exports.DEFAULT_STYLES = exports.SCREEN_OFFSET = void 0;
exports.SCREEN_OFFSET = 16;
/**
 * Order of keys here is responsible for the order of styles applied
 */
exports.DEFAULT_STYLES = {
    width: "auto",
    height: "auto",
    position: "absolute",
};
exports.RESET_STYLES = {
    position: "fixed",
    opacity: 0,
    animation: "none",
    transition: "none",
};
